import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

interface ITimerStyles {
  ended: boolean;
}

export const useStyles = makeStyles<Theme, ITimerStyles>((theme) => ({
  timer: {
    display: "flex",
    textAlign: "center",
    padding: "0 .5rem",
    borderRadius: 5,
    color: (props) => {
      if (props.ended) {
        return theme.palette.red.main;
      }

      return theme.palette.text.primary;
    },
  },
  restartButton: {
    "& svg": {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
    marginLeft: theme.spacing(0.5),
    padding: 0,
  },
}));
